import { createEquipmentTypeValidator } from 'utils/yup';
import type { TWizardFeatureGroup } from 'constants/wizards/types';
import { projectTypeToSchemaMap } from './Features';

type TEquipmentTypeSchema = ReturnType<typeof createEquipmentTypeValidator>;

export interface IGetPartOfValidationSchemaArgs {
  projectType: string;
  groupName: TWizardFeatureGroup;
}

export const getPartOfValidationSchema = ({
  projectType,
  groupName,
}: IGetPartOfValidationSchemaArgs): Record<string, TEquipmentTypeSchema> => {
  const featuresSchema = projectTypeToSchemaMap[projectType] || [];
  return featuresSchema
    .filter(({ group }) => group === groupName)
    .reduce<Record<string, TEquipmentTypeSchema>>((schema, feature) => {
      const tmp: Record<string, TEquipmentTypeSchema> = {};
      if (Array.isArray(feature.form)) {
        feature.form.forEach((field) => {
          if (field.name.includes('equipment_type')) {
            tmp[field.name] = createEquipmentTypeValidator(feature.name);
          }
        });
      }
      return { ...schema, ...tmp };
    }, {});
};
